import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchRenditionPaid, selectRenditionPaidState } from "../redux/slices/renditionPaidSlice"
import { ApiStatus } from "../types/api/status"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { RenditionPaidAPI } from "../apis/RenditionPaidAPI"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"

export const useRenditionPaidStore = () => {
  const dispatch = useDispatch()
  const { renditionPaids, status, selectedRenditionPaid } = useSelector(selectRenditionPaidState)
  
  const userData = readLocalStorage(LocalStorageKey.USER_DATA)
  const idcompany = userData?.data?.idcompany

    const getRenditionPaids = async (data?: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await RenditionPaidAPI.getRenditionPaids(idcompany, data)
            if (!response?.status) {
              dispatch(changeStatus(ApiStatus.FETCHED))
              return CustomSnackbar('error', response.data.message || "");
            }
            const { detail } = response.data
            dispatch(onFetchRenditionPaid(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return true
        } catch (error) {
          console.log(error)
          return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createRenditionPaid = async (data: any) => {
      try {
        dispatch(changeStatus(ApiStatus.FETCHING))
        const response = await RenditionPaidAPI.create(data)
        if (!response?.status) {
          dispatch(changeStatus(ApiStatus.FETCHED))
          return CustomSnackbar('error', response.data.message || "")
        }
        dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('success', response.data.message || '')
        return response.data.detail
      } catch (error) {
        console.log(error)
        return dispatch(changeStatus(ApiStatus.FETCHED))
      }
    }

    const validateRenditionPaid = async (id: number, data: any) => {
      try {
          dispatch(changeStatus(ApiStatus.FETCHING))
          const response = await RenditionPaidAPI.validate(id, idcompany, data)
          if (!response?.status) {
            dispatch(changeStatus(ApiStatus.FETCHED))
            return CustomSnackbar('error', response.data.message || "")
          }
          dispatch(changeStatus(ApiStatus.FETCHED))
          CustomSnackbar('success', response.data.message  || "")
          return true
      } catch (error) {
        console.log(error)
        return dispatch(changeStatus(ApiStatus.FETCHED))
      }
    }

    return {
        //states
        renditionPaids,
        status,
        selectedRenditionPaid,
        //actions
        getRenditionPaids,
        validateRenditionPaid,
        createRenditionPaid
    }
}